import type { FrontendWidget } from '../types';
import { SnippetReferenceComponent } from './SnippetReferenceComponent';
import { SnippetReferenceComponentB } from './SnippetReferenceComponentB';
import { SnippetReferenceComponentC } from './SnippetReferenceComponentC';
import type { SnippetReferenceConfig, SnippetReferenceResolved } from './types';

export const snippetReferenceWidget: FrontendWidget<
  SnippetReferenceConfig,
  SnippetReferenceResolved
> = {
  componentType: 'widgets.snippet-reference',
  // 70.14: adds no geometry — the snippet's blocks replace it, and each one
  // gets the page container from the renderer. Wrapping here as well would
  // box in a `gradient-section` or `hero` the snippet contains.
  layout: 'self',
  displayName: 'Snippet Reference',
  defaultValues: { additionalTags: [] },
  ComponentA: SnippetReferenceComponent,
  ComponentB: SnippetReferenceComponentB,
  ComponentC: SnippetReferenceComponentC,
  // No resolveSync — this is a lookup widget. Resolved data arrives from
  // POST /api/resolve-widgets (§4 + §6).
};
